import type { ShopperSearch } from '@/scapi';
import {
    createProductUrl as upstreamCreateProductUrl,
    getDecoratedVariationAttributes as upstreamGetDecoratedVariationAttributes,
    type DecoratedVariationAttribute,
} from '@/lib/product/product-utils';
import { createProductHierarchyUrl, getSearchHitHierarchyUrl } from './hierarchy-url';

export function createProductUrl(
    productId: string | undefined,
    selectedAttributeValue?: string | null,
    attributeType?: string,
    variantPid?: string | null,
    hierarchyUrl?: string | null
): string {
    if (hierarchyUrl) {
        return createProductHierarchyUrl(productId, hierarchyUrl, {
            selectedAttributeValue,
            attributeType,
            variantPid,
        });
    }
    return upstreamCreateProductUrl(productId, selectedAttributeValue, attributeType, variantPid);
}

/** Swatch links use the hierarchy PDP URL when `c_hierarchyUrl` is set. */
export function getDecoratedVariationAttributes(
    product: ShopperSearch.schemas['ProductSearchHit'],
    opts: { swatchViewType?: string } = {}
): DecoratedVariationAttribute[] {
    const hierarchyUrl = getSearchHitHierarchyUrl(product);
    const variationAttributes = upstreamGetDecoratedVariationAttributes(product, opts);

    if (!hierarchyUrl) {
        return variationAttributes;
    }

    return variationAttributes.map((variationAttribute) => ({
        ...variationAttribute,
        values: variationAttribute.values.map((value) => ({
            ...value,
            href: createProductUrl(
                product.productId,
                value.value,
                variationAttribute.id || 'color',
                null,
                hierarchyUrl
            ),
        })),
    }));
}

export type { DecoratedVariationAttribute, DecoratedVariationAttributeValue } from '@/lib/product/product-utils';
